import InformationModalType from "./InformationModalType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { dispatch } from "../../state/configureStore";

interface InformationModalState {
  isOpen: boolean;
  title: string;
  message: string;
  modalType: InformationModalType;
}

const initialState = {
  isOpen: false,
  message: "",
  modalType: InformationModalType.Error,
  title: "",
};

const slice = createSlice({
  name: "InformationModalState",
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<{ title: string; message: string; modalType: InformationModalType }>) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.title = action.payload.title;
      state.modalType = action.payload.modalType;
    },
    closeModal: state => {
      state.isOpen = false;
      state.message = "";
      state.title = "";
      state.modalType = InformationModalType.Error;
    },
  },
});

export const showErrorModal = (title: string, message: string): void => {
  dispatch(
    slice.actions.showModal({
      message: message,
      title: title,
      modalType: InformationModalType.Error,
    }),
  );
};

export const showWarningModal = (title: string, message: string): void => {
  dispatch(
    slice.actions.showModal({
      message: message,
      title: title,
      modalType: InformationModalType.Warning,
    }),
  );
};

export const showInformationModal = (title: string, message: string): void => {
  dispatch(
    slice.actions.showModal({
      message: message,
      title: title,
      modalType: InformationModalType.Information,
    }),
  );
};

export const closeInformationModal = (): void => {
  dispatch(slice.actions.closeModal());
};

export type { InformationModalState };

export default slice.reducer;
